import { Stack, Typography } from '@mui/material'
import { TAttribute } from 'types/models'

export const WheatCodeRowDetails = ({
  name,
  range_max,
  range_min,
  range_avg,
}: TAttribute) => {
  return (
    <Stack
      px="18px"
      bgcolor="white"
      height={48}
      direction="row"
      alignItems="center"
      spacing={2}
    >
      <Typography width={200} fontWeight="700">
        {name}
      </Typography>
      <Typography fontSize={13} width={70}>
        {range_min} - {range_max}
      </Typography>
      <Typography fontSize={13} width={70}>
        Ave. {range_avg}
      </Typography>
    </Stack>
  )
}
